import { AllowedSystemEnum } from 'enums/allowedSystem.enum';
import { copyToClipboard } from 'utils/util';

export const FOOTER_COLUMNS: Array<{
  title: string;
  items: Array<{
    text: string;
    url?: string;
    allowedSystem?: AllowedSystemEnum;
    icon?: string;
    small?: boolean;
    onClick?: () => void;
  }>;
}> = [
  {
    title: 'explore',
    items: [
      {
        text: 'veilingHolambra',
        url: 'https://veiling.com.br',
        icon: 'OpenInNew',
      },
      {
        text: 'umentor',
        url: 'https://painel.umentor.com.br/cadastro_treinamento/?con_cod=vei386474&pla=5',
        icon: 'OpenInNew',
      },
    ],
  },
  {
    title: 'apps',
    items: [
      {
        text: 'clientPortal',
        url: process.env.REACT_APP_CUSTOMER_BASE_URL,
        allowedSystem: AllowedSystemEnum.Customer,
        icon: 'OpenInNew',
      },
      {
        text: 'producerPortal',
        url: process.env.REACT_APP_PRODUCER_BASE_URL,
        allowedSystem: AllowedSystemEnum.VeilingOnline,
        icon: 'OpenInNew',
      },
      {
        text: 'administrativeSystem',
        url: process.env.REACT_APP_INTERNAL_BASE_URL,
        allowedSystem: AllowedSystemEnum.Internal,
        icon: 'OpenInNew',
      },
      {
        text: 'userManagement',
        url: process.env.REACT_APP_SSO_MANAGEMENT,
        icon: 'OpenInNew',
      },
    ],
  },
  {
    title: 'sac',
    items: [
      {
        text: 'phoneNumber',
      },
      {
        text: 'attendence',
        small: true,
      },
      {
        text: 'email',
        icon: 'ContentCopy',
        onClick: () => copyToClipboard('sac@cvh.com.br'),
      },
      {
        text: 'privacyWarning',
        url: 'https://veiling.com.br/aviso-de-privacidade',
      },
    ],
  },
];
